import styled from '@emotion/styled';
import { getColor } from '../common/UICommon';

export const CardContainer = styled.div`
  margin-bottom: 16px;
  align-items: center;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: 8;
  border-radius: 16px;
`;

export const CardHeader = styled.div`
  border-radius: 16px 16px 0px 0px;
  padding: 16px 0 8px 0;
  align-items: center;
  background: linear-gradient(90deg, ${getColor('PURPLE_60')} 0%, ${getColor('FUCHSIA_60')} 100%);
`;

export const CardAvatarWrapper = styled.div`
  align-self: center;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
`;

export const GfName = styled.div`
  width: 100%;
  color: ${getColor('WHITE')};
  text-align: center;
  align-self: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const GfTitle = styled.div`
  color: ${getColor('WHITE')};
  text-align: center;
  align-self: center;
  font-weight: 500;
  line-height: 18px;
  font-size: 12px;
`;

export const CardBody = styled.div`
  background-color: ${getColor('WHITE')};
  border-radius: 0 0 16px 16px;
  padding: 8px 24px 24px 24px;
`;

export const GroupTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 12px;
  color: ${getColor('BLACK')};
`;

export const GroupSegment = styled.div`
  color: ${getColor('PURPLE_60')};
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
`;

export const GroupTime = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
`;

export const GroupLive = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${getColor('RED_100')};
  margin-bottom: 4px;
`;

export const GroupLiveText = styled.span`
  margin-left: 8px;
`;
